exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bonus_send_tabs[data-v-5f234aae] {\n  padding: 12px;\n}\n", ""]);

// exports
